import { NODE_JSON_SERVER_IGNORED_FIELDS, NODE_SERVER_IGNORED_FIELDS } from "Areas/SharedFeatures/types/nodeSource";
import omit from "lodash/omit";
import values from "lodash/values";
import map from "lodash/map";
import { EDGE_JSON_SERVER_IGNORED_FIELDS, EDGE_SERVER_IGNORED_FIELDS } from "Areas/SharedFeatures/types/edgeSource";
export const prepareDocumentGraphData = ({ documentId, prevData, nodesSource, edgesSource, model, groups, nodes, edges, dataGroups }) => ({
    Id: documentId,
    GraphModel: model !== null && model !== void 0 ? model : prevData.GraphModel,
    NodesSource: map(nodesSource, s => omit(s, NODE_SERVER_IGNORED_FIELDS)),
    EdgesSource: map(edgesSource !== null && edgesSource !== void 0 ? edgesSource : values(prevData.EdgesSource), s => omit(s, EDGE_SERVER_IGNORED_FIELDS)),
    Nodes: map(nodes, s => omit(s, NODE_JSON_SERVER_IGNORED_FIELDS)),
    Edges: map(edges, s => omit(s, EDGE_JSON_SERVER_IGNORED_FIELDS)),
    DataGroups: map(dataGroups, s => omit(s, NODE_JSON_SERVER_IGNORED_FIELDS)),
    LayoutAlgorithm: prevData.LayoutAlgorithm,
    Groups: groups || values(prevData.Groups)
});
